import React, { useContext, useState } from 'react'
import moment from 'moment'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Button, FormControlLabel } from '@mui/material'
import { PTSDutiesContext } from '..'

const AddExistingShift = ({ form, handleChange, open, onClose }) => {
  const [shiftsToAdd, setShiftsToAdd] = useState([])

  const { shiftsWithoutDuty, setShiftsWithoutDuty } =
    useContext(PTSDutiesContext)

  const handleSubmit = () => {
    const merged = [...(form.crewShifts || []), ...shiftsToAdd].filter(
      (shift, index, arr) =>
        arr.findIndex((x) => x._id === shift._id) === index,
    )
    handleChange('crewShifts', merged)
    setShiftsWithoutDuty((prev) =>
      prev.filter((shift) => !shiftsToAdd.some((x) => x._id === shift._id)),
    )
    setShiftsToAdd([])
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Stack gap={1}>
          <Typography>
            Select the shifts you wish to add to this duty
          </Typography>
          {(shiftsWithoutDuty ?? []).map((s) => (
            <FormControlLabel
              key={s._id}
              label={`${moment(s.start).format('HH:mm')} -
                ${moment(s.end).format('HH:mm')} (${s.clinicalRole})`}
              control={
                <Checkbox
                  checked={shiftsToAdd.some((x) => x._id === s._id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setShiftsToAdd((prev) => [...prev, s])
                    } else {
                      setShiftsToAdd((prev) =>
                        prev.filter((x) => x._id !== s._id),
                      )
                    }
                  }}
                />
              }
            />
          ))}
          <Button
            fullWidth
            variant="outlined"
            color="anRed"
            onClick={() => {
              setShiftsToAdd([])
              onClose()
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="anGreen"
            onClick={() => {
              handleSubmit()
            }}
          >
            Submit
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default AddExistingShift
